export default {

  /**
   * Find the day programs that a hotel selection should be copied to.
   *
   * A hotel is chosen for a single day, but a stay normally spans several days in
   * the same area, so the selection is copied to the neighbouring days to save the
   * user from repeating the same choice for every night.
   *
   * @param dayProgramItems
   * @param editedDayProgramId
   * @returns {Array}
   */
  getPropagationTargetIds(dayProgramItems, editedDayProgramId) {
    const editedDay = dayProgramItems.find(dayProgram => dayProgram.id === editedDayProgramId);

    if (!editedDay) {
      return [];
    }

    // Days in the same area + country as the edited day.
    const areaDays = dayProgramItems
      .filter(dayProgram => dayProgram.areaId === editedDay.areaId
        && dayProgram.countryId === editedDay.countryId)
      .sort((a, b) => a.day - b.day);

    // The last day in an area is typically the travel home day and must never get a hotel automatically.
    const lastAreaDay = areaDays[areaDays.length - 1];

    if (editedDay.id === lastAreaDay.id) {
      return [];
    }

    const targetIds = [];

    for (let i = 0; i < areaDays.length; i += 1) {
      const dayProgram = areaDays[i];

      if (dayProgram.day <= editedDay.day || dayProgram.id === lastAreaDay.id) {
        continue;
      }

      // Stop when another hotel stay already starts.
      // This prevents changing the end hotel from overwriting the start hotel.
      if (dayProgram.hotelCount) {
        break;
      }

      targetIds.push(dayProgram.id);
    }

    return targetIds;
  },
};



// WEBPACK FOOTER //
// ./src/utils/dayProgramHotels.js